export const LLMType = {
    CHATGPT: 1,
    GEMINI: 2,
};